import {useEffect} from "react";
import {message} from "antd";
import T from "../services/language";
import {useNavigate, useParams} from "react-router-dom";
import {useApp} from "../contexts/app";
import Environment from "../environment";

export default function useSessionCompleted() {
    let {
        groupSlug,
        shareUrlKey,
        campaignId,
        customerId,
        productServiceId,
        productServiceType,
        quantity,
        packageIndex, postalCode, locationType
    }: any = useParams();
    const navigate = useNavigate();
    const {addAnswered, getAnswered, getLocalProductService, clientCode} = useApp();

    useEffect(() => {
        try {
            if (!Environment.canBackSupport) {
                if (getSessionDone(campaignId, customerId)) {
                    message.error(T("You have completed the booking process"));
                    // Back to landing page with both URL segments preserved
                    navigate(`/${groupSlug}/${shareUrlKey}`, {replace: true});
                }
            }
        } catch (e) {
            console.error(e);
        }
    }, []);

    return {
        set: () => setSessionDone(campaignId, customerId),
    }
}


// 2026-05-05 — moved from sessionStorage to localStorage. sessionStorage is
// per-tab and lost on tab close, so a user who closed the success tab and
// reopened the booking URL (PWA shortcut, bookmarked deep-link, mobile tab
// killed by OS) saw a clean slate and could re-enter the flow. localStorage
// persists across tabs and across browser restarts for the same origin, so
// the guard fires on Question/Confirm/Booking mount even after a refresh.
// The Success page's "Done" handler still calls localStorage.clear() to wipe
// this flag when the user explicitly finishes — that's the intended exit.
const setSessionDone = (campaignId, customerId) => {
    window.localStorage.setItem(`session-done-${campaignId}-${customerId}`, "true");
}

const getSessionDone = (campaignId, customerId) => {
    return !!window.localStorage.getItem(`session-done-${campaignId}-${customerId}`);
}